import {Controller} from "stimulus"
import $ from 'jquery';
import {set_locale} from "./localize_controller";
import bootbox from "bootbox/bootbox";
import consumer from "../channels/consumer";

let position = null;
let notifications_array = [];
let locale = 'es';
let colors = {
    'Urgente': '#ef4035',
    'Advertencia': '#e9a04e',
    'Notificacion': '#1479ab',
    'Success': '#14ab37'
}
let offset = 0;

let mark_as_read = (id = null) => {
    let items = document.getElementsByClassName('carousel-item-notification');
    let identificador = '';
    for (let i = 0; i < items.length; i++) {
        if (items[i].classList.contains('active')) {
            if (id === null) {
                identificador = items[i].getAttribute('data-notification-id');
            } else {
                identificador = id;
            }
            $.ajax({
                url: `${location.origin}/${locale}/read/notification_push/${identificador}`,
                data: {format: 'json'},
                type: 'GET',
                success: function (data) {
                    let find_notification = $('#notification_push_message').find(`a[data-position="${position}"]`)
                    if (find_notification.length > 0) {
                        find_notification[0].remove();
                    }
                }
            })
        }
    }

}
let show_alerts = (elem) => {
    let indicator = '';
    let carousel = '';
    let pos = position;

    // array.map((elem, key) => {
    //     let active = '';
    //     if (key === 0) {
    //         active = 'active';
    //     }
    if (elem.icon.includes('fa')) {
        elem.icon = `fa ${elem.icon}`;
    }

    indicator += `<li data-target="#carouselNotification" data-slide-to="0" class="active mark_ad_read" data-read-id="${elem.id}"></li>`
    carousel += ` <div class="carousel-item carousel-item-notification active" data-interval="30000" data-notification-id="${elem.id}">
                               <div class="carousel-body">
                                    <p class="body-title" style="--icon-color:${colors[elem.type]};"><span class="${elem.icon} text-justify carousel-icon mr-2" ></span> ${elem.title}</p>
                                   <div style="max-height: 55vh; overflow: auto">
                                     <p>${elem.description}</p>
                                   </div>
                                </div>

                            </div>`
    // })

    bootbox.dialog({
        message: `<button class="close-modal-login" type="button" data-dismiss="modal"></button>
                        <div id="carouselNotification" class="carousel slide" data-ride="carousel">
                          <ol class="carousel-indicators">
                           ${indicator}
                          </ol>
                          <div id="carousel-inner" class="carousel-inner">
                           ${carousel}
                          </div>
                        </div>
`,
        onShow: function (e) {
            mark_as_read();
            // let mar = document.getElementsByClassName('mark_ad_read');
            // for(var i=0;i<mar.length;i++){
            //     mar[i].addEventListener('click',function (e) {
            //         mark_as_read(e.target.dataset.readId);
            //     })
            // }
        },
        onEscape: false,
        buttons: {
            ok: {
                label: "<span class='fa fa-check'></span> Leido",
                className: 'btn-info',
                callback: function () {
                    // console.log('Custom OK clicked');
                }
            }
        }
    });

}

let count_and_show_data_notification = (array, count_area, message_area) => new Promise((result, reject) => {
    let html = '';
    if (count_area !== null && count_area !== undefined)
        if (array.length > 0) {
            count_area.classList.add('badge-error-modify');
            $(count_area).css('--color-red', 'rgb(193,66,66)');

            count_area.parentNode.setAttribute('title', `${array.length} notificaciones sin leer.`)
            notifications_array = array;


            array.map((element, index) => {
                if (element.icon.includes('fa')) {
                    element.icon = `fa ${element.icon}`;
                }

                html += `<a href="javascript:;" class="dropdown-item mark_ad_read" data-action="notificationPush#show" data-position="${index}" style="display: grid;
                                                            grid-template-columns: .1fr 1fr .2fr;
                                                            grid-auto-flow: dense;gap: 10px;">
                    <span data-position="${index}"  class="${element.icon}" style="
                                                            position: relative;
                                                            display: inline-flex;
                                                            justify-content: center;
                                                            align-items: center;
                                                            padding: 0 0 0 3px;
                                                            color: ${colors[element.type]};"></span>
                    <span data-position="${index}"> ${element.title} </span>
                    <span data-position="${index}" class="text-muted" style="font-size: .9em;">   ${element.date}</span>
                    </a>`
            })

        } else {
            count_area.classList.remove('badge-error');
            $(count_area).css('--color-red', '#b5b0b0');
            html += `<a href="javascript:;" class="dropdown-item" style="display: grid;
                                                            grid-template-columns: .1fr 1fr .2fr;
                                                            grid-auto-flow: dense;gap: 10px;">
                    <span   class="icon-speech" style="     position: relative;
                                                            display: inline-flex;
                                                            justify-content: center;
                                                            align-items: center;
                                                            padding: 0 0 0 3px;
                                                            color: #666;"></span>
                    <span > No hay notificaciones para mostrar </span>
                    <span  class="text-muted" style="font-size: .9em;">   </span>
                    </a>`
        }
    if (message_area !== null && message_area !== undefined) {
        message_area.innerHTML = html + message_area.innerHTML;
    }

    result(true)
})

let load_notifications = (offset = 0, limit = 100, type = '') => new Promise((resolve, reject) => {
    $.ajax({
        url: `${location.origin}/${locale}/get/notification_push`,
        data: {format: 'json', offset: offset, limit: limit, type: type},
        type: 'GET',
        success: function (data) {
            resolve(data)
        }
    })
})

export default class extends Controller {

    initialize() {
        let context = this;
        let notifiy_user = document.getElementById('user_notification_id');
        let notification_count = document.getElementById('notification_push_count');
        let notification_message = document.getElementById('notification_push_message');
        let bell = document.getElementById('bell');
        if (notifiy_user !== null) {
            if (!location.pathname.includes('admin') || !location.pathname.includes('maintenance') || !location.pathname.includes('initial')) {
                const user_id = Number(notifiy_user.getAttribute('data-user-id'));
                const notification_push = consumer.subscriptions.create({
                    channel: "NotificationPushChannel",
                    user_id: user_id
                }, {
                    connected() {
                        console.log('Conected channel NotificationPushChannel' + user_id)
                        load_notifications(offset, 10).then(
                            data => {
                                count_and_show_data_notification(data, notification_count, notification_message).then(
                                    result => {

                                        setTimeout(function () {
                                            notification_message.addEventListener('scroll', function () {
                                                console.log('scroll' + this.scrollHeight)
                                                const alturaTotal = this.scrollHeight;
                                                const alturaVisible = this.clientHeight;
                                                const posicionActual = this.scrollTop;

                                                // Detectar cuando llega al final
                                                if (posicionActual >= alturaTotal - alturaVisible) {
                                                    offset = offset + 1;

                                                    load_notifications(offset, 100).then(
                                                        data => {
                                                            count_and_show_data_notification(data, notification_count, notification_message).then()
                                                        })
                                                }

                                                // Detectar cuando llega al inicio
                                                if (posicionActual === 0) {
                                                    console.log('Llegaste al inicio');
                                                }
                                            });
                                        }, 1000)
                                    }
                                )
                            }
                        )
                    },

                    disconnected() {
                        // Called when the subscription has been terminated by the server
                    },

                    received(data) {
                        switch (data.type) {
                            case 'push':
                                const tone_message = document.getElementById('tone_message');
                                tone_message.play();
                                notifications_array.unshift(data.notification);

                                if (data.notification.type === 'Urgente') {
                                    context.direct_show(data.notification);
                                }

                                notification_count.classList.add('agrandar');
                                bell.classList.add('bell-ring');
                                setTimeout(() => {
                                    notification_count.classList.remove('agrandar');
                                    bell.classList.remove('agrandar');
                                }, 60000)
                                count_and_show_data_notification(notifications_array, notification_count, notification_message).then();


                                break;
                            case 'connection':
                                let datos = data.notification;
                                toastr[datos.type](datos.msg, datos.error)
                                break;
                            case 'reservation':
                                let check_ofac = $('#check_ofac')
                                let reservation_number_id = $('#reservation_number_id')
                                if (reservation_number_id.val() === data.id) {
                                    if (data.type_action === 'accept') {
                                        toastr.info('Los usuarios administradores después de una revisión manual de el cliente que solicita la reserva, han aprobado al cliente, por favor puede continuar con le proceso.')
                                        check_ofac[0].value = false;
                                        document.dispatchEvent(
                                            new CustomEvent("set-form-update", {
                                                bubbles: true,
                                                detail: {
                                                    value: {
                                                        step_form: 2,
                                                        sign: '-',
                                                        formnumber: parseInt(data.formnumber),
                                                        button: data.button,
                                                        check_ofac: false
                                                    }
                                                }
                                            })
                                        )
                                    } else {
                                        toastr.error('El proceso de confirmación de la reserva no ha sido aprobado por los administradores. El cliente se confirmo que se encuentra en las listas de sanciones de la OFAC.')
                                        check_ofac[0].value = true;
                                        setTimeout(() => {
                                            location.reload()
                                        }, 3000)
                                    }
                                }
                                break;
                        }
                    }
                });
            }
        }
    }

    connect() {
        load_notifications(0, 1, 'Urgente').then(data => {
            if (data.length > 0) {
                this.direct_show(data[0])
            }
        })
    }

    show(e) {
        position = e.target.dataset.position;
        show_alerts(notifications_array[e.target.dataset.position]);
    }

    direct_show(data) {
        show_alerts(data);
    }

    setAsRead(e) {
        $.ajax({
            url: `${location.origin}/${locale}/read/notification_push/${e.target.dataset.id}`,
            data: {format: 'json'},
            type: 'GET',
            beforeSend: function () {
                $(e.target)[0].innerHTML = `<span class="fa fa-circle-o-notch fa-spin"></span>`
            },
            success: function (data) {
                if (data.success) {
                    let target = $(e.target);
                    let notification_status = $(`#notification_status_${e.target.dataset.id}`);
                    target[0].classList.remove('btn-info');
                    target[0].classList.add('btn-success');
                    target[0].innerHTML = `<span class="fa fa-check"></span>`

                    notification_status[0].innerHTML = `<span class="badge badge-secondary">Leido</span>`;

                    setTimeout(() => {
                        target.fadeTo(1000).delay(1000).remove();
                    }, 1000);
                }

            }
        })
    }
}